<template>
    <v-layout style="box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, .3);height: 100%;overflow: hidden;padding: 0px;margin: 0px;">
        <div id="virtual-page"
             style="position: absolute;top: 0;left:0;width: 156mm;height:0mm;z-index: -1;"></div>
        <v-container
                style="padding: 0px;margin: 0px;width: 400px;flex-shrink: 0;overflow: auto;max-height:720px;">
            <v-simple-form title="">
                <template v-slot:toolbar>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="goBack">
                        <v-icon color="gray">mdi-step-backward</v-icon>
                        返回
                    </v-btn>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="onSave">
                        <v-icon color="gray">mdi-content-save</v-icon>
                        保存
                    </v-btn>
                    <v-btn :loading="$store.getters.loading['DOC_DOWNLOAD']" text tile small color="rgba(0,0,0,.7)"
                           @click="onRefresh">
                        <v-icon color="gray">mdi-refresh</v-icon>
                        刷新
                    </v-btn>
                    <v-btn text tile small color="rgba(0,0,0,.7)" @click="onEdit">
                        <v-icon color="gray">mdi-file-word-box</v-icon>
                        编辑
                    </v-btn>
                    <v-spacer/>
                </template>
                <template v-slot:content>
                    <!--                    <v-form-file ref="contentFile"-->
                    <!--                                 upload-api="DOC_CONTENT_UPLOAD"-->
                    <!--                                 @uploaded="onUploaded"-->
                    <!--                                 :field-width="300" vertical :label-width="70"-->
                    <!--                                 v-model="dataItem.docFileName" return-url-->
                    <!--                                 label="上传word"></v-form-file>-->
                    <v-form-textarea :field-width="350" :height="300" vertical v-model="dataItem.content" label="正文">

                    </v-form-textarea>
                    <v-form-field :field-width="300" vertical :label-width="70" v-model="dataItem.lineHeight"
                                  label="行高">
                        <template v-slot:append>
                            <v-btn small icon color="primary" @click="plus('lineHeight')">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn small icon color="primary" @click="minus('lineHeight')">
                                <v-icon>mdi-minus-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-form-field>
                    <v-form-field :field-width="300" vertical :label-width="70" v-model="dataItem.minSideBearing"
                                  label="最小间距">
                        <template v-slot:append>
                            <v-btn small icon color="primary" @click="plus('minSideBearing')">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn small icon color="primary" @click="minus('minSideBearing')">
                                <v-icon>mdi-minus-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-form-field>

                    <v-form-field :field-width="300" vertical :label-width="70" v-model="dataItem.wordSideBearing"
                                  label="单词间距">
                        <template v-slot:append>
                            <v-btn small icon color="primary" @click="plus('wordSideBearing')">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn small icon color="primary" @click="minus('wordSideBearing')">
                                <v-icon>mdi-minus-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-form-field>

                    <v-form-field :field-width="300" vertical :label-width="70" v-model="dataItem.fontName"
                                  label="字体名称">
                    </v-form-field>

                    <v-form-field :field-width="300" vertical :label-width="70" v-model="dataItem.fontSize"
                                  label="字体大小">
                        <template v-slot:append>
                            <v-btn small icon color="primary" @click="plus('fontSize')">
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                            <v-btn small icon color="primary" @click="minus('fontSize')">
                                <v-icon>mdi-minus-circle</v-icon>
                            </v-btn>
                        </template>
                    </v-form-field>


                </template>
            </v-simple-form>
        </v-container>
        <v-container class="ma-0 pa-0" style="padding: 0px;margin: 0px;">
            <div class="ma-0 pa-0"
                 style="max-height: 720px;overflow:auto;background-color: #e0e0e0;">
                <div class="page"
                     style="padding-bottom:25mm;position:relative;width: 210mm;min-height: 225mm;background: white;box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);margin: 5mm auto;">
                    <div style="position: relative;margin-left: 28mm;margin-right: 26mm;">
                        <div v-html="html"
                             style="font-family: 仿宋_GB2312;font-size: 16pt">
                        </div>
                    </div>
                </div>
            </div>
        </v-container>
    </v-layout>
</template>

<script>

    export default {
        name: "TypeEngine.vue",
        // 先后走进教室、操场，观看同学们书法练习和体育锻炼，同大家亲切交流。总书记说：“中华民族复兴，靠
        data() {
            return {
                html: null,
                docHtml: null,
                docId: null,
                dataItem: {
                    id: null,
                    minSideBearing: 300,
                    wordSideBearing: 300,
                    content: "几个月前，2021年9月14日，习近平总书记来到绥德实验中学，先后走进教室、操场，观看同学们书法练习和体育锻炼，同大家亲切交流。总书记说：“中华民族复兴，靠的是什么？靠的是我们民族有高度文明的精神素养，基础在于教育。五千年中华民族文明的基础也在于教育。泱泱大国几千年的兴盛，教育至关重要。”",
                    lineHeight: 30,
                    fontName: "仿宋_GB2312",
                    fontSize: 16
                }
            }
        },
        created() {
            window.theApp.$emit("APP_DRAWER_TOGGLED");
            this.docId = this.$route.query.id;
            if (this.docId) {
                this.queryDetail(this.docId);
            }
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },

            plus(attribute) {
                this.dataItem[attribute] = this.dataItem[attribute] + 1;
                this.onConvert();
            },

            minus(attribute) {
                this.dataItem[attribute] = this.dataItem[attribute] - 1;
                this.onConvert();
            },

            queryDetail(id) {
                this.$request
                    .request("DOC_DETAIL", {rowid: id})
                    .then(response => {
                        this.dataItem = Object.assign(this.dataItem, response.data)
                        this.doc = Object.assign(this.doc, JSON.parse(response.data.docStyle));
                    });
            },
            onEdit() {
                window.open("/editor.html?type=fullHtml&id=" + this.docId, '_blank');
            },
            onRefresh() {
                this.onConvert();
            },
            onUploaded(items) {
                if (items && items.length > 0) {
                    this.dataItem.docFileId = items[0].id;
                    this.dataItem.docFileName = items[0].fileName;
                    this.docHtml = items[0].tag;
                    //  this.docHtml = "<p>" + this.docHtml + "</p>";
                    this.html = this.$tool.conert2PageHtml2(items[0].tag);
                    //   this.onConvert();
                }
            },

            /**
             * 将文本转换为标准公文html格式
             * @param c
             * @returns {string}
             */
            onConvert() {
                let param = {
                    content: this.dataItem.content,
                    configuration: {
                        pageWidth: 442.2,
                        pageHeight: 637.8,
                        fontName: this.dataItem.fontName,
                        fontSize: this.dataItem.fontSize,
                        lineHeight: this.dataItem.lineHeight,
                        minSideBearing: this.dataItem.minSideBearing,
                        wordSideBearing: this.dataItem.wordSideBearing
                    }
                }
                this.$request.request('DOC_HTML_CONVERT', param).then(response => {
                    this.html = response.data;
                })
            }
        }
    }
</script>